import { render } from "./AuthLoggedInComponent.vue?vue&type=template&id=01a84520&ts=true"
import script from "./AuthLoggedInComponent.vue?vue&type=script&lang=ts"
export * from "./AuthLoggedInComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__